/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiBaseService } from '../api-base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CheckCartResult } from '../models/check-cart-result';
import { CreateOrderResult } from '../models/create-order-result';
import { getByOrderid } from '../fn/orders/get-by-orderid';
import { GetByOrderid$Params } from '../fn/orders/get-by-orderid';
import { GetOrderResult } from '../models/get-order-result';
import { getOrders } from '../fn/orders/get-orders';
import { GetOrders$Params } from '../fn/orders/get-orders';
import { GetOrdersResult } from '../models/get-orders-result';
import { getOrderssummary } from '../fn/orders/get-orderssummary';
import { GetOrderssummary$Params } from '../fn/orders/get-orderssummary';
import { GetOrdersSummaryResult } from '../models/get-orders-summary-result';
import { patchByOrderidTablenumber } from '../fn/orders/patch-by-orderid-tablenumber';
import { PatchByOrderidTablenumber$Params } from '../fn/orders/patch-by-orderid-tablenumber';
import { postByOrderidCancel } from '../fn/orders/post-by-orderid-cancel';
import { PostByOrderidCancel$Params } from '../fn/orders/post-by-orderid-cancel';
import { postCheckcart } from '../fn/orders/post-checkcart';
import { PostCheckcart$Params } from '../fn/orders/post-checkcart';
import { postOrders } from '../fn/orders/post-orders';
import { PostOrders$Params } from '../fn/orders/post-orders';

@Injectable({ providedIn: 'root' })
export class ApiOrdersService extends ApiBaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postOrdersByOrderidCancel()` */
  static readonly PostOrdersByOrderidCancelPath = '/Orders/{OrderId}/cancel';

  /**
   * post-orders-by-orderid-cancel.
   *
   * Annule la commande
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postByOrderidCancel()` instead.
   *
   * This method doesn't expect any request body.
   */
  postByOrderidCancel$Response(params: PostByOrderidCancel$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return postByOrderidCancel(this.http, this.rootUrl, params, context);
  }

  /**
   * post-orders-by-orderid-cancel.
   *
   * Annule la commande
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postByOrderidCancel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postByOrderidCancel(params: PostByOrderidCancel$Params, context?: HttpContext): Observable<boolean> {
    return this.postByOrderidCancel$Response(params, context).pipe(map((r: StrictHttpResponse<boolean>): boolean => r.body));
  }

  /** Path part for operation `postOrdersCheckcart()` */
  static readonly PostOrdersCheckcartPath = '/Orders/checkCart';

  /**
   * post-orders-checkcart.
   *
   * Summary<br>Description
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postCheckcart()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postCheckcart$Response(params?: PostCheckcart$Params, context?: HttpContext): Observable<StrictHttpResponse<CheckCartResult>> {
    return postCheckcart(this.http, this.rootUrl, params, context);
  }

  /**
   * post-orders-checkcart.
   *
   * Summary<br>Description
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postCheckcart$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postCheckcart(params?: PostCheckcart$Params, context?: HttpContext): Observable<CheckCartResult> {
    return this.postCheckcart$Response(params, context).pipe(map((r: StrictHttpResponse<CheckCartResult>): CheckCartResult => r.body));
  }

  /** Path part for operation `getOrders()` */
  static readonly GetOrdersPath = '/Orders';

  /**
   * get-orders.
   *
   * Summary<br>Description
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrders()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrders$Response(params?: GetOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrdersResult>> {
    return getOrders(this.http, this.rootUrl, params, context);
  }

  /**
   * get-orders.
   *
   * Summary<br>Description
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrders(params?: GetOrders$Params, context?: HttpContext): Observable<GetOrdersResult> {
    return this.getOrders$Response(params, context).pipe(map((r: StrictHttpResponse<GetOrdersResult>): GetOrdersResult => r.body));
  }

  /** Path part for operation `postOrders()` */
  static readonly PostOrdersPath = '/Orders';

  /**
   * post-orders.
   *
   * Summary<br>Description
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postOrders()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postOrders$Response(params?: PostOrders$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateOrderResult>> {
    return postOrders(this.http, this.rootUrl, params, context);
  }

  /**
   * post-orders.
   *
   * Summary<br>Description
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postOrders$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postOrders(params?: PostOrders$Params, context?: HttpContext): Observable<CreateOrderResult> {
    return this.postOrders$Response(params, context).pipe(map((r: StrictHttpResponse<CreateOrderResult>): CreateOrderResult => r.body));
  }

  /** Path part for operation `getOrdersByOrderid()` */
  static readonly GetOrdersByOrderidPath = '/Orders/{OrderId}';

  /**
   * get-orders-by-orderid.
   *
   * Summary<br>Description
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getByOrderid()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByOrderid$Response(params: GetByOrderid$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderResult>> {
    return getByOrderid(this.http, this.rootUrl, params, context);
  }

  /**
   * get-orders-by-orderid.
   *
   * Summary<br>Description
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getByOrderid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getByOrderid(params: GetByOrderid$Params, context?: HttpContext): Observable<GetOrderResult> {
    return this.getByOrderid$Response(params, context).pipe(map((r: StrictHttpResponse<GetOrderResult>): GetOrderResult => r.body));
  }

  /** Path part for operation `getOrdersOrderssummary()` */
  static readonly GetOrdersOrderssummaryPath = '/Orders/ordersSummary';

  /**
   * get-orders-orderssummary.
   *
   * Summary<br>Description
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOrderssummary()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrderssummary$Response(params?: GetOrderssummary$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrdersSummaryResult>> {
    return getOrderssummary(this.http, this.rootUrl, params, context);
  }

  /**
   * get-orders-orderssummary.
   *
   * Summary<br>Description
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOrderssummary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOrderssummary(params?: GetOrderssummary$Params, context?: HttpContext): Observable<GetOrdersSummaryResult> {
    return this.getOrderssummary$Response(params, context).pipe(map((r: StrictHttpResponse<GetOrdersSummaryResult>): GetOrdersSummaryResult => r.body));
  }

  /** Path part for operation `patchOrdersByOrderidTablenumber()` */
  static readonly PatchOrdersByOrderidTablenumberPath = '/Orders/{OrderId}/tableNumber';

  /**
   * patch-orders-by-orderid-tablenumber.
   *
   * Modifie le numéro de table de la commande
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchByOrderidTablenumber()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchByOrderidTablenumber$Response(params: PatchByOrderidTablenumber$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return patchByOrderidTablenumber(this.http, this.rootUrl, params, context);
  }

  /**
   * patch-orders-by-orderid-tablenumber.
   *
   * Modifie le numéro de table de la commande
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchByOrderidTablenumber$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchByOrderidTablenumber(params: PatchByOrderidTablenumber$Params, context?: HttpContext): Observable<boolean> {
    return this.patchByOrderidTablenumber$Response(params, context).pipe(map((r: StrictHttpResponse<boolean>): boolean => r.body));
  }
}
